import React from "react";
import YhModal from "../../ui/YhModal";

export type CallingLeadRow = {
  leadId: string;
  uid?: string;
  leadName?: string;
  phone?: string;
  stage?: string;
  source?: string;
  form?: string;
  project?: string;
  date?: string;
  assignedDate?: string;
  createdDate?: string;
};

type Props = {
  open: boolean;
  title: string;
  loading?: boolean;
  leads: CallingLeadRow[];
  onClose: () => void;
};

const CallingLeadsModal: React.FC<Props> = ({
  open,
  title,
  loading,
  leads,
  onClose,
}) => {
  return (
    <YhModal open={open} onClose={onClose} title={title} width={1040}>
      {loading ? (
        <p className="py-6 text-sm text-[#6B7280]">Loading leads…</p>
      ) : !leads.length ? (
        <p className="py-6 text-sm text-[#6B7280]">No leads in this cell.</p>
      ) : (
        <div className="max-h-[70vh] overflow-auto">
          <table className="w-full border-separate border-spacing-0 text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wide text-[#6B7280]">
                <th className="sticky top-0 bg-white px-3 py-2 font-semibold">Lead</th>
                <th className="sticky top-0 bg-white px-3 py-2 font-semibold">Status</th>
                <th className="sticky top-0 bg-white px-3 py-2 font-semibold">
                  Assigned date
                </th>
                <th className="sticky top-0 bg-white px-3 py-2 font-semibold">
                  Created date
                </th>
                <th className="sticky top-0 bg-white px-3 py-2 font-semibold">Phone</th>
                <th className="sticky top-0 bg-white px-3 py-2 font-semibold">Project</th>
                <th className="sticky top-0 bg-white px-3 py-2 font-semibold">Source</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((lead, index) => (
                <tr
                  key={`${lead.leadId || lead.uid || "lead"}-${index}`}
                  className="border-t border-[#F3F4F6]"
                >
                  <td className="px-3 py-2.5">
                    <div className="font-semibold text-[#111827]">
                      {lead.leadName || "—"}
                    </div>
                    <div className="text-xs text-[#6B7280]">{lead.uid || ""}</div>
                  </td>
                  <td className="whitespace-nowrap px-3 py-2.5 font-medium text-[#111827]">
                    {lead.stage || "—"}
                  </td>
                  <td className="whitespace-nowrap px-3 py-2.5 tabular-nums text-[#4B5563]">
                    {lead.assignedDate || lead.date || "—"}
                  </td>
                  <td className="whitespace-nowrap px-3 py-2.5 tabular-nums text-[#4B5563]">
                    {lead.createdDate || "—"}
                  </td>
                  <td className="whitespace-nowrap px-3 py-2.5 text-[#4B5563]">
                    {lead.phone || "—"}
                  </td>
                  <td className="px-3 py-2.5 text-[#4B5563]">
                    {lead.project || lead.form || "—"}
                  </td>
                  <td className="whitespace-nowrap px-3 py-2.5 text-[#4B5563]">
                    {lead.source || "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </YhModal>
  );
};

export default CallingLeadsModal;
